import { useState, useEffect } from 'react'
import Hero from '../../components/Hero'
import { Link, useNavigate } from 'react-router-dom'
import Card from '../../components/Card'

import axios from 'axios';
import { useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import { Helmet } from 'react-helmet';

export default function DistrictPage() {

    const url = process.env.REACT_APP_API_URL;

    const districtURL = url + "business_district";

    const [district, setDistrict] = useState<any>(null);
    const [publications, setPublications] = useState<any>(null);

    const { slug } = useParams();
    const navigate = useNavigate()
    const asyncLoadDistricts = async () => {
        try {
            const response = await axios.get(districtURL, {
                params: {
                    'slug': slug,
                    '_embed': 'wp:featuredmedia'
                }
            })
            const hasBusinessDistricts = response.data?.length > 0
            if (!response.data) {
                navigate('/error/404')
                return
            }
            const data = response.data[0]
            setDistrict(data)
        } catch (error: any) {
            console.log(error.message)
        }
    }

    const asyncLoadPublications = async () => {
        try {
            const response = await axios.get(url + "publication", {
                params: {
                    "per_page": 3,
                    "_embed": "wp:featuredmedia,wp:term,author"
                }
            })
            const hasBusinessDistricts = response.data.length > 0;
            if (!hasBusinessDistricts) {
                navigate('/error/404')
                return
            }
            const data = response.data
            setPublications(data)
        } catch (error: any) {
            console.log(error.message)
        }
    }
    useEffect(() => {
        // axios.get(districtURL, {
        //     params: {
        //         'slug': slug,
        //         '_embed': 'wp:featuredmedia'
        //     }
        // }).then((response) => {
        //     const hasBusinessDistricts = response.data?.length > 0
        //     if (!hasBusinessDistricts) {
        //         navigate('/error/404')
        //         return
        //     }
        //     setDistrict(response.data[0]);
        // })

        // axios.get(url + "publication", {
        //     params: {
        //         "per_page": 3,
        //         "_embed": "wp:featuredmedia,wp:term,author"
        //     }
        // }).then((response) => {
        //     setPublications(response.data);
        // })

        (
            async () => {
                await asyncLoadDistricts()
                await asyncLoadPublications()
            }
        )()
    }, [district])
    const description = district?.content?.rendered?.replace(/<[^>]*>/g, '')
    const keywordBuilder = `${district?.acf?.blurb}, ${district?.acf?.cmci_ranking}, ${district?.slug}`
    const meta = {
        title: 'Business Districts | PRIME Philippines',
        description: description,
        canonical: window.location + '',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: `PRIME Philippines, ${keywordBuilder}`
            },
            itemProp: {
                name: 'Business Districts | PRIME Philippines',
                description: description,
                image: 'https://www.primephilippines.com/media/logos/prime-logo.webp',
            },
            property: {
                'og:title': 'Business Districts | PRIME Philippines',
                'og:description': description,
                'og:image': 'https://www.primephilippines.com/media/logos/prime-logo.webp',
                'og:url': window.location + '',
                'og:type': 'website',
                'twitter:title': 'Business Districts | PRIME Philippines',
                'twitter:description': description,
                'twitter:image': 'https://www.primephilippines.com/media/logos/prime-logo.webp',
                'twitter:url': window.location + '',
            }
        },
        auto: {
            ograph: true
        }
    }
    return (
        <>
            <Helmet>
                <title>{meta?.title}</title>
                <meta name="description" content={meta?.description} />
                <link rel="canonical" href={meta?.canonical} />
                <meta charSet={meta?.meta?.charset} />
                <meta name="keywords" content={meta?.meta?.name.keywords} />
                <meta name={meta?.meta?.itemProp.name} content={meta?.meta?.itemProp.name} />
                <meta name={meta?.meta?.itemProp.description} content={meta?.meta?.itemProp.description} />
                <meta name={meta?.meta?.itemProp.image} content={meta?.meta?.itemProp.image} />

                <meta property="og:title" content={meta?.meta?.property['og:title']} />
                <meta property="og:description" content={meta?.meta?.property['og:description']} />
                <meta property="og:image" content={meta?.meta?.property['og:image']} />
                <meta property="og:url" content={meta?.meta?.property['og:url']} />
                <meta property="og:type" content={meta?.meta?.property['og:type']} />

                <meta name="twitter:title" content={meta?.meta?.property['twitter:title']} />
                <meta name="twitter:description" content={meta?.meta?.property['twitter:description']} />
                <meta name="twitter:image" content={meta?.meta?.property['twitter:image']} />
                <meta name="twitter:url" content={meta?.meta?.property['twitter:url']} />
            </Helmet>
            <div>

                {
                    district ?
                        <Hero
                            image={district._embedded['wp:featuredmedia'][0].source_url}
                            height="15rem"
                            className="object-cover"
                            alignment="justify-content-center"
                        >
                            <h1 className="display-6 text-center text-white">{district.title.rendered}</h1>
                        </Hero>
                        : <Loading />
                }


                <div className="mt-10">
                    <h1>Description</h1>
                    {district && <p className="fs-4" dangerouslySetInnerHTML={{ __html: district.content.rendered }}></p>}
                </div>

                <hr />
                {
                    district ?
                        <div className="row m-10 fs-5">
                            {
                                district.acf.total_office_supply &&
                                <div className="col-4 ">
                                    <div className="border border-primary border-2 p-4" style={{ height: "10rem" }}>
                                        <h4 className="uppercase text-primary">Total Office Supply ({district.acf.office_supply_year} H1 in sqm)</h4>
                                        <p>{district.acf.total_office_supply}</p>
                                    </div>
                                </div>
                            }
                            {
                                district.acf.cmci_ranking &&
                                <div className="col-4 ">
                                    <div className="border border-primary border-2 p-4" style={{ height: "10rem" }}>
                                        <h4 className="uppercase text-primary">{district.acf.cmci_year} CMCI Ranking</h4>
                                        <p>{district.acf.cmci_ranking}</p>
                                    </div>
                                </div>
                            }
                            {
                                district.acf.land_area &&
                                <div className="col-4 ">
                                    <div className="border border-primary border-2 p-4" style={{ height: "10rem" }}>
                                        <h4 className="uppercase text-primary">Land Area</h4>
                                        <p>{district.acf.land_area}</p>
                                    </div>
                                </div>
                            }
                            {
                                district.acf.population &&
                                <div className="col-4 ">
                                    <div className="border border-primary border-2 p-4" style={{ height: "10rem" }}>
                                        <h3>Population</h3>
                                        <p>{district.acf.population}</p>
                                    </div>
                                </div>
                            }
                        </div>
                        : <Loading />
                }


                <div className="mx-20">
                    <h3 className="fs-1 fw-bold">New Publications</h3>
                    <div className="row g-2">
                        {
                            publications?.length > 0 ?
                                <>
                                    {
                                        publications.map((publication: any, index: number) => (
                                            <Card
                                                class="col-12 col-md-3 col-sm-12 h-100"
                                                imageClass="pt-5"
                                                bodyClass="fs-6 text-truncate-two"
                                                key={index + "pub"}
                                                titleTextColor="text-primary"
                                                subtitleTextColor="text-grey-700"
                                                image={publication._embedded["wp:featuredmedia"][0].source_url}
                                                title={publication.title.rendered}
                                                date={new Date(publication.date).toDateString().split(' ').slice(1).join(' ')}
                                                body={publication.body}
                                                link={"/publications/" + publication.slug}
                                            />
                                        ))
                                    }
                                    <div className="col-12 col-md-3 col-sm-12">
                                        <div className="card align-text-bottom h-100">
                                            <img loading="lazy" src="/media/publications/publications-view-more.webp" className="h-100 img-fluid" alt="More Publications" />
                                            <div className="card-img-overlay bg-primary opacity-75">

                                            </div>
                                            <div className="card-img-overlay d-flex align-items-end">
                                                <Link to="/publications"><h2 className="card-title text-start opacity-100 text-secondary fw-bold">CHECK THE REST OF OUR PUBLICATIONS</h2></Link>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                : <Loading />
                        }
                    </div>
                </div>

            </div >
        </>

    )
}